import React, { useState, useEffect } from 'react'
import Title from "../../containers/title/title";
import { getImageUrl } from '../../../utils/imageUrl';

const RoadTripAndAchievements = ({ timeLineData }) => {
    const [width, setWidth] = useState(0)
    const numberOfRows = Math.ceil(timeLineData?.timeline?.length / 3);
    const rows = Array.from({ length: numberOfRows }, (_, i) =>
        timeLineData.timeline.slice(i * 3, i * 3 + 3)
    );
    const handleResize = () => setWidth(window.innerWidth);
    useEffect(() => {
        setWidth(window.innerWidth)
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        }
    }, []);
    return (
        <>
            <style>
                {`
          @media (max-width: 1191px) {
            .container {
              padding: 0 !important;
              gap: 0 !important;
            }
            .row {
              flex-direction: column;
              align-items: flex-start;
              gap: 0 !important;
            }
            .circle-container {
              flex-direction: row !important;
              text-align: left;
              width: 100% !important;
              align-items: center;
              padding: 25px;
              gap: 15px;
            }
            .circle-wrapper {
              margin: 0 !important;
              }
              .circle-image {
              width: 70px !important;
              height: 70px !important;
              border: 3px solid #C52542 !important;
            }
            .content {
              flex: 1;
              margin: 30px 0 0 !important;
              font-weight: 400;
              color: #0D2133;
            }
            .content .title {
                font-weight: 700;
                color: #C52542 !important;
                font-size: 16px;
                text-transform: capitalize;
            }
            .content .year {
                font-size: 16px;
            }
            .content .description {
                font-size: 11px;
            }
            .horizontal-line {
              display: none !important;
            }
            .vertical-line {
              display: block;
              position: absolute;
              left: 26px;
              top: 73px;
              width: 22px;
              height: 60px;
              background: #C52542;
            }
            .last-circle .vertical-line {
              display: none !important;
            }
          }
            @media (min-width: 1191px) {
            .vertical-line {
              display: none !important
            }
            .content .title {
                font-size: 28px;
                font-weight: 700;
                margin-bottom: 5px;
                color: #C52542 !important;
                text-transform: capitalize;
            }
            .content .year, .content .description {
                font-size: 20px;
            }
        }
        `}
            </style>
            <Title title={timeLineData?.title} />
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                margin: 0,
            }}>
                <div className="container" style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '130px',
                    direction: 'ltr',
                    padding: '50px',
                    position: 'relative'
                }}>
                    {rows.map((rowItems, rowIndex) => (
                        <Row key={rowIndex} isLast={rowIndex === numberOfRows - 1}>
                            {rowItems.map((item, itemIndex) => (
                                <CircleContainer
                                    key={`${item.year}-${itemIndex}`} // Unique key
                                    title={item.title}
                                    year={item.year}
                                    description={item.achievement}
                                    hasLine={width >= 1191 ? itemIndex < rowItems.length - 1 : true} // Line only for non-last items in the row
                                    isLast={
                                        rowIndex === numberOfRows - 1 &&
                                        itemIndex === rowItems.length - 1
                                    }
                                    image={getImageUrl(item.image)} // Pass image if needed in CircleContainer
                                />
                            ))}
                        </Row>
                    ))}
                </div>
            </div>
        </>
    )
}

const CircleContainer = ({ title, year, description, image, hasLine = false, isLast = false }) => (
    <div className={['circle-container', isLast ? 'last-circle' : ''].join(" ")} style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        width: '392px',
        position: 'relative',
        // padding: '15px'
    }}>
        <div className="circle-wrapper" style={{
            borderRadius: '50%',
            position: 'relative',
            marginBottom: '15px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'white'
        }}>
            <img
                src={image}
                alt={title}
                className="circle-image"
                style={{
                    width: '275px',
                    height: '275px',
                    objectFit: 'cover',
                    borderRadius: '50%',
                    border: '8px solid #C52542',
                    zIndex: 1
                }}
            />
            {hasLine && (
                <>
                    <div className="horizontal-line" style={{
                        position: 'absolute',
                        top: '50%',
                        left: '98%',
                        width: '100%',
                        height: '22px',
                        background: '#C52542',
                        zIndex: 0
                    }} >
                        <div className="horizontal-line" style={{
                            position: 'absolute',
                            top: '2px',
                            width: '100%',
                            height: '18px',
                            background: '#0D2133'
                        }} >
                            <div className="horizontal-line" style={{
                                position: 'absolute',
                                top: '8px',
                                width: '100%',
                                height: '2px',
                                background: 'white'
                            }} />
                        </div>
                    </div>
                    <div className="vertical-line">
                        <div className="vertical-line" style={{
                            position: 'absolute',
                            left: '2px',
                            top: '0',
                            width: '18px',
                            height: '100%',
                            background: '#0D2133'
                        }} >
                            <div className="vertical-line" style={{
                                position: 'absolute',
                                left: '8px',
                                top: '0px',
                                width: '2px',
                                height: '100%',
                                background: 'white'
                            }} />
                        </div>
                    </div>
                </>
            )}
        </div>
        <div className="content">
            <div className="title">{title}</div>
            <div className="year">{year}</div>
            <div className="description">{description}</div>
        </div>
    </div>
)

const Row = ({ children, isLast = false }) => (
    <div className="row" style={{
        display: 'flex',
        gap: '50px',
        position: 'relative'
    }}>
        {children}
        {!isLast && (
            <div className="horizontal-line" style={{
                position: 'absolute',
                width: '50rem',
                height: '22px',
                background: '#C52542',
                transform: 'rotate(149deg)',
                transformOrigin: 'left center',
                top: '12rem',
                left: '61.5rem',
                opacity: '20%',
            }} >
                <div className="horizontal-line" style={{
                    position: 'absolute',
                    top: '2px',
                    width: '100%',
                    height: '18px',
                    background: '#0D2133'
                }} >
                    <div className="horizontal-line" style={{
                        position: 'absolute',
                        top: '8px',
                        width: '100%',
                        height: '2px',
                        background: 'white'
                    }} />
                </div>
            </div>
        )}
    </div>
)

export default RoadTripAndAchievements